import { request } from '@/lib/api'
import type { FilterSpec } from './types'

/**
 * Теги и сегменты (тикет #105).
 *
 * Помечаемые сущности перечислены и на сервере (`ListCatalog.TAGGABLE`), и в CHECK таблицы
 * `entity_tag`; здесь — чтобы не показывать панель там, где сервер ответит отказом.
 */
export const TAGGABLE = new Set(['sales.counterparty', 'sales.contact', 'sales.deal', 'sales.lead'])

export interface Tag {
  id: string
  name: string
  color?: string | null
}

export interface TagResult {
  requested: number
  affected: number
  tagId: string
  tagName: string
}

export interface Segment {
  id: string
  name: string
  entity: string
  filters: FilterSpec[]
  shared: boolean
  mine: boolean
  count: number
}

export const fetchTags = (signal?: AbortSignal) =>
  request<{ tags: Tag[] }>('/tags', { signal }).then((r) => r.tags)

export const updateTag = (id: string, body: { name?: string; color?: string }) =>
  request<Tag>(`/tags/${id}`, { method: 'PUT', body })

export const deleteTag = (id: string) => request<void>(`/tags/${id}`, { method: 'DELETE' })

export const bulkTag = (entity: string, ids: string[], tagName: string, remove: boolean) =>
  request<TagResult>(`/lists/${encodeURIComponent(entity)}/bulk/tags`, {
    method: 'POST',
    body: { ids, tagName, remove },
  })

export const fetchSegments = (entity: string, signal?: AbortSignal) =>
  request<{ segments: Segment[] }>(`/segments?entity=${encodeURIComponent(entity)}`, { signal }).then(
    (r) => r.segments,
  )

export const createSegment = (body: { name: string; entity: string; filters: FilterSpec[]; shared: boolean }) =>
  request<Segment>('/segments', { method: 'POST', body })

export const deleteSegment = (id: string) => request<void>(`/segments/${id}`, { method: 'DELETE' })
